import { useLayoutEffect } from 'react';
export function useDocumentTitle(title) {
    useLayoutEffect(() => {
        const previous = document.title;
        document.title = title;
        return () => {
            document.title = previous;
        };
    }, [title]);
}
//# sourceMappingURL=index.js.map